"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _FormControl = require("../FormControl");
var _formControlState = _interopRequireDefault(require("../FormControl/formControlState"));
var _FormLabel = _interopRequireDefault(require("../FormLabel"));
var _tss = require("../styles/tss");
var _exposeClasses = require("../utilities/exposeClasses");
var _responsiveProps = require("../utilities/responsiveProps");
const _excluded = ["textTransform"],
  _excluded2 = ["textTransform"],
  _excluded3 = ["textTransform"],
  _excluded4 = ["className", "classes", "disableAnimation", "shrink", "exposeClasses"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsInputLabel',
  uniqId: 'iZuwZK'
})((theme, _params, classes) => {
  const {
    spacing,
    typography
  } = theme.busbud;
  const inputStyle = theme.busbud.colors.component.textfield;
  const _typography$font$comp = typography.font.component.label.xxs,
    {
      textTransform: textTransformXxs
    } = _typography$font$comp,
    labelXxs = (0, _objectWithoutProperties2.default)(_typography$font$comp, _excluded);
  const _typography$font$comp2 = typography.font.component.label.xxs,
    {
      textTransform: textTransformXs
    } = _typography$font$comp2,
    labelXs = (0, _objectWithoutProperties2.default)(_typography$font$comp2, _excluded2);
  const _typography$font$comp3 = typography.font.component.label.lg,
    {
      textTransform: textTransformLg
    } = _typography$font$comp3,
    labelLg = (0, _objectWithoutProperties2.default)(_typography$font$comp3, _excluded3);
  const sizeCssDefinitions = {
    size: {
      sm: {
        [`&.${classes.formControl}`]: {
          left: spacing(1.5),
          top: spacing(3),
          [`&.${classes.shrink}`]: {
            transform: `translateY(-50%) translateY(${spacing(-1)})`
          }
        }
      },
      md: {
        [`&.${classes.formControl}`]: {
          left: spacing(1.5),
          top: spacing(3.5),
          [`&.${classes.focused}`]: _objectSpread(_objectSpread({}, labelXs), {}, {
            // Error on casting string to a valid textTransform value
            // TODO remove when legacy theme is removed
            textTransform: textTransformXs
          }),
          [`&.${classes.expanded}`]: _objectSpread(_objectSpread({}, labelXs), {}, {
            // Error on casting string to a valid textTransform value
            // TODO remove when legacy theme is removed
            textTransform: textTransformXs
          }),
          [`&.${classes.shrink}`]: {
            transform: `translateY(-50%) translateY(${spacing(-1.25)})`
          }
        }
      }
    }
  };
  return _objectSpread({
    /* Styles applied to the root element. */
    root: _objectSpread(_objectSpread({
      display: 'block',
      transformOrigin: 'top left'
    }, labelLg), {}, {
      // Error on casting string to a valid textTransform value
      // TODO remove when legacy theme is removed
      textTransform: textTransformLg,
      color: inputStyle.normal.label,
      zIndex: 2,
      pointerEvents: 'none'
    }),
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {
      color: inputStyle.disabled.label
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {
      color: inputStyle.error.label
    },
    expanded: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},
    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      right: spacing(0.5),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      transform: `translateY(-50%)`
    },
    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: _objectSpread(_objectSpread({}, labelXxs), {}, {
      // Error on casting string to a valid textTransform value
      // TODO remove when legacy theme is removed
      textTransform: textTransformXxs,
      color: inputStyle.normal.label,
      fontWeight: theme.busbud.fontWeight.heavy,
      [`&.${classes.focused}`]: {
        color: inputStyle.focused.label
      },
      [`&.${classes.disabled}`]: {
        color: inputStyle.disabled.label
      },
      [`&.${classes.error}`]: {
        color: inputStyle.error.label
      }
    }),
    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform', 'font-size'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    }
  }, (0, _responsiveProps.generateUnoptimizedResponsiveStyles)(theme, sizeCssDefinitions));
});
/**
 * **❗️ DEPRECATED**: Use the new `Input` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/forms-input):
 *
 * ```tsx
 * import { Input } from "@busbud/horizon";
 * ```
 *
 * `InputLabel` contains styles and logic for the label element of `Textfield`.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-api-inputlabel--page)
 */
const InputLabel = /*#__PURE__*/_react.default.forwardRef(function InputLabel(props, ref) {
  const {
      className,
      classes: classesOverrides,
      disableAnimation = false,
      shrink: shrinkProp,
      exposeClasses
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded4);
  const {
    classes,
    cx
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  const dsFormControl = (0, _FormControl.useFormControl)();
  let shrink = shrinkProp;
  if (typeof shrink === 'undefined' && dsFormControl) {
    shrink = dsFormControl.filled || dsFormControl.focused || dsFormControl.hasPlaceholder && dsFormControl.expanded;
  }
  const fcs = (0, _formControlState.default)({
    props,
    dsFormControl,
    states: ['size', 'variant']
  });
  const sizeClasses = (0, _responsiveProps.getResponsiveClassNamesForProp)(fcs.size || 'md', 'size').map(classe => classes[classe]);
  const exposedClassesAttributes = exposeClasses ? (0, _exposeClasses.getExposedClasses)('DsInputLabel', classes, ['disabled', 'error', 'focused']) : {};
  return /*#__PURE__*/_react.default.createElement(_FormLabel.default, (0, _extends2.default)({}, exposedClassesAttributes, {
    "data-shrink": shrink,
    className: cx(classes.root, ...sizeClasses, {
      [classes.formControl]: !!dsFormControl,
      [classes.animated]: !disableAnimation,
      [classes.shrink]: shrink,
      [classes.expanded]: !!dsFormControl && !!dsFormControl.expanded
    }, className),
    classes: {
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required,
      asterisk: classes.asterisk
    },
    ref: ref
  }, other));
});
var _default = exports.default = InputLabel;